


























































import { Vue, Component } from 'vue-property-decorator';
import { Manual } from '@/modules/manual';

@Component
export default class ManualList extends Vue {
  get loading(): boolean {
    return this.$store.state.manual.loading;
  }

  get manualList(): Manual[] {
    return this.$store.state.manual.manualList;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('manual/fetchManualList');
  }

  private sizeFormatter(row: Manual) {
    if (!row.size) {
      return '';
    } else {
      if (row.size < 1024) {
        return `${row.size} byte`;
      } else if (row.size < 1024 * 1024) {
        return `${(row.size / 1024).toFixed(1)} KB`;
      } else {
        return `${(row.size / (1024 * 1024)).toFixed(1)} MB`;
      }
    }
  }

  private updateDateFormatter(row: Manual) {
    if (!row.updateDate) {
      return '';
    } else {
      return (this as any).$moment(row.updateDate).format('YYYY/MM/DD HH:mm');
    }
  }

  private async onDownload(row: Manual) {
    const link = document.createElement('a');
    link.href = row.url;
    link.setAttribute('download', row.name);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
